import type {
  VisualizationDTO,
  VisualizationInsertDTO,
  VisualizationType,
} from '@tempo-io/roadmap-dto';
import { HTTPError } from 'ky';
import { tempoApi } from '../tempoApi';

const fetchAllVisualizations = async (viewId: number): Promise<VisualizationDTO[]> => {
  const response = await tempoApi()
    .get(`api/v1/loop-visualization/view/${viewId}/visualization`)
    .json<VisualizationDTO[]>();
  return response;
};

const fetchVisualization = async (
  viewId: number,
  visualizationId: number,
): Promise<VisualizationDTO> => {
  const response = await tempoApi()
    .get(`api/v1/loop-visualization/view/${viewId}/visualization/${visualizationId}`)
    .json<VisualizationDTO>();
  return response;
};

const fetchVisualizationByType = async (
  viewId: number,
  type: VisualizationType,
): Promise<VisualizationDTO | null> => {
  try {
    const response = await tempoApi()
      .get(`api/v1/loop-visualization/view/${viewId}/visualization/type/${type}`)
      .json<VisualizationDTO | null>();
    return response;
  } catch (err: unknown) {
    if (err instanceof HTTPError && err.response.status === 404) {
      return null;
    }
    throw err;
  }
};

const upsertVisualization = async (
  viewId: number,
  data: VisualizationInsertDTO,
): Promise<VisualizationDTO> => {
  const response = await tempoApi()
    .put(`api/v1/loop-visualization/view/${viewId}/visualization`, {
      json: data,
    })
    .json<VisualizationDTO>();
  return response;
};

const deleteVisualization = async (viewId: number, visualizationId: number): Promise<void> => {
  await tempoApi().delete(
    `api/v1/loop-visualization/view/${viewId}/visualization/${visualizationId}`,
  );
};

export const VisualizationApi = {
  fetchAllVisualizations,
  fetchVisualization,
  fetchVisualizationByType,
  upsertVisualization,
  deleteVisualization,
} as const;
